/*eslint-disable no-unused-vars */
/*eslint-disable no-useless-escape */
/*eslint-disable react-hooks/exhaustive-deps*/
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setLoadingOverlay } from '../../store/slices/loadingOverlaySlice';
import { useCallback, useEffect, useRef, useState } from 'react';
import LocalstorageService from '../../helpers/localstorage-service';
import { formatNumberRTL } from '../../helpers';
import { CompanyId, INSERT_LOADING_TERMINAL_DATE_KEY, JobRole, USER_ROLE } from '../../constants';
import { Button, Col, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import MachineService from '../../services/machines';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { t } from 'i18next';
import EmployeeService from '../../services/employee';
import { Form, Formik } from 'formik';
import ReactSelect from 'react-select';
import { NumericFormat } from 'react-number-format';
import ReactDatePicker from 'react-datepicker';
import RemarkModal from './RemarkModal';
import NoRecords from '../../components/Table/NoRecords';
import SortableHeader from '../../components/SortableHeader';
// import ActionBtns from '../../components/ActionBtns';
import debounce from 'lodash.debounce';
import LocationService from '../../services/Location';
import TerminalIssuesModal from './TerminalIssuesModal';
import DeleteCalculationModal from './DeleteCalculationModal';
import TerminalIssuesService from '../../services/TerminalIssues';
import { getIsraelBusinessDate } from '../../helpers/dateUtils';

const ListEmployeeTerminals = () => {
  const dispatch = useDispatch();
  const [setPageTitle, setCrumbItem] = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [empList, setEmpList] = useState([]);
  const [empId, setEmpId] = useState(0);
  const reqPayload = {};
  const formRef = useRef();
  const empListLoaded = useRef(false);
  let companyId = LocalstorageService.getItem(CompanyId);

  const [date, setDate] = useState(getIsraelBusinessDate);
  const [showAllEmployeeRecords, setShowAllEmployeeRecords] = useState(true);
  const [showRemarkModal, setShowRemarkModal] = useState({ shown: false, remarkId: '', terminalNumber: '', locationName: '' });
  const [amountEmployeeHave, setAmountEmployeeHave] = useState('');
  const [totalLoadAmount, setTotalLoadAmount] = useState('');
  const [claimAmount, setClaimAmount] = useState('');
  const [search, setSearch] = useState('');
  const [changeCellValue, setChangeCellValue] = useState({ oldValue: '', newValue: '' });
  const roleId = LocalstorageService.getItem(JobRole);

  // Sort state - default sort by loadingAmount descending
  const [currentSort, setCurrentSort] = useState([{ value: 'loadingAmount', asc: false }]);

  // New state variables for location counts
  const [locationsToLoadCount, setLocationsToLoadCount] = useState(0);
  const [fifthsCount, setFifthsCount] = useState(0);

  // Terminal Issues Modal state
  const [showIssuesModal, setShowIssuesModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [issuesCount, setIssuesCount] = useState(0);

  const InitialValues = {
    totalLoadAmount: '',
    employee: '',
    amount: '',
    allEmployee: true,
  };

  useEffect(() => {
    setPageTitle(t('LOADING_TERMINAL.TITLE'));
    setCrumbItem([
      { title: t('APPLICATION_TITLE'), link: '#' },
      { title: t('LOADING_TERMINAL.TITLE'), link: '#' },
    ]);

    // getEmployeeFn moved into loadAllData for parallel execution
    checkIssuesCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkIssuesCount = async () => {
    if (roleId !== USER_ROLE.COMPANY_ADMIN && roleId !== USER_ROLE.SUPER_ADMIN) return;
    try {
      const response = await TerminalIssuesService.checkTerminalIssues({ companyId });
      setIssuesCount(response.data.totalCount || 0);
    } catch (error) {
      console.error('Error checking issues:', error);
    }
  };

  const fetchRecords = () => {
    reqPayload.companyId = companyId;
    reqPayload.dateS = date.toLocaleDateString('en-US');
    reqPayload.employeeId = showAllEmployeeRecords ? 0 : empId;
    // Apply current sort
    if (currentSort && currentSort.length > 0) {
      reqPayload.sort = currentSort;
    }

    listFn();
  };

  async function fetchRemainCash(reqPayload) {
    dispatch(setLoadingOverlay(true));
    await LocationService.getRemainCash(reqPayload)
      .then((response) => {
        const { data } = response.data;
        setAmountEmployeeHave(data?.totalCashRemain || 0);
      })
      .finally(() => {
        dispatch(setLoadingOverlay(false));
      });
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedChangeHandler = useCallback(debounce(updateSearch, 500), []);

  function updateSearch(e) {
    setSearch(e.target.value?.trim());
  }

  const moveToNextDayAfterNoon = () => {
    let timerId = null;
    const israelTimeZone = 'Asia/Jerusalem';

    const getNextDate = (currentDate) => {
      const nextDate = new Date(currentDate);
      nextDate.setDate(currentDate.getDate() + 1);
      return nextDate;
    };

    const callUpdateLoadingTerminalData = (nextDate) => {
      const day = nextDate.getDate();
      const month = nextDate.getMonth();
      const year = nextDate.getFullYear();
      const dateForWhichInsertLoadingTerminalData = parseInt(
        `${year}${month + 1 <= 9 ? '0' : ''}${month + 1}${day <= 9 ? '0' : ''}${day}`,
      );
      try {
        const dtArr = LocalstorageService.getItem(INSERT_LOADING_TERMINAL_DATE_KEY);
        if (dtArr && dtArr[0]) {
          const dtInt = parseInt(dtArr[0]);
          if (dtInt < dateForWhichInsertLoadingTerminalData) {
            updateLoadingTerminalData({ dateS: nextDate.toLocaleDateString('en-US') });
            LocalstorageService.setItem(INSERT_LOADING_TERMINAL_DATE_KEY, [dateForWhichInsertLoadingTerminalData]);
          }
        } else {
          updateLoadingTerminalData({ dateS: nextDate.toLocaleDateString('en-US') });
          LocalstorageService.setItem(INSERT_LOADING_TERMINAL_DATE_KEY, [dateForWhichInsertLoadingTerminalData]);
        }
      } catch (error) {
        updateLoadingTerminalData({ dateS: nextDate.toLocaleDateString('en-US') });
        LocalstorageService.setItem(INSERT_LOADING_TERMINAL_DATE_KEY, [dateForWhichInsertLoadingTerminalData]);
      }
    };

    const checkTime = () => {
      const date = new Date();

      const israelTime = date.toLocaleTimeString('en-US', {
        timeZone: israelTimeZone,
        hour12: false,
      });
      const currentHour = israelTime.split(':')[0];
      if (currentHour >= 17) {
        const nextDate = getNextDate(date);
        // callUpdateLoadingTerminalData(nextDate);
        setDate(nextDate);
        clearInterval(timerId);

        timerId = null;
      }
    };

    timerId = setInterval(checkTime, 1000);
  };

  useEffect(() => {
    // Consolidated data loading with single loading overlay
    const loadAllData = async () => {
      delete reqPayload['search'];
      if (search) {
        reqPayload['search'] = search;
      }

      dispatch(setLoadingOverlay(true));
      setIsLoading(true);

      try {
        // Build all promises
        const promises = [];

        // 0. Fetch employee list (only on first load)
        if (!empListLoaded.current) {
          promises.push(
            EmployeeService.listEmployee({ companyId })
              .then((response) => {
                const { status, dataList } = response.data;
                if (status !== 400 && dataList && dataList.length) {
                  const data = dataList.map((item) => ({
                    id: item.id,
                    label: `${item.firstName} ${item.lastName}`,
                    value: item.id,
                    companyId: item.companyId,
                  }));
                  setEmpList(data);
                }
                empListLoaded.current = true;
              })
              .catch(() => { empListLoaded.current = true; })
          );
        }

        // 1. Fetch remain cash (only if empId exists)
        if (empId) {
          promises.push(
            LocationService.getRemainCash({ employeeId: empId })
              .then((response) => {
                const { data } = response.data;
                setAmountEmployeeHave(data?.totalCashRemain || 0);
              })
              .catch(() => setAmountEmployeeHave(''))
          );
        } else {
          setAmountEmployeeHave('');
        }

        // 2. Get total amount to load
        promises.push(
          MachineService.toAmountToLoad({
            dateS: date.toLocaleDateString('en-US'),
            companyId: companyId,
            employeeId: empId || 0,
          }).then((response) => {
            const { status, dataList } = response.data;
            if (status !== 400 && dataList?.length > 0) {
              if ((empId || 0) <= 0) {
                setTotalLoadAmount(dataList[0].totalAmountToLoad);
                setClaimAmount('');
              } else {
                setClaimAmount(dataList[0].totalAmountToLoad);
              }
            }
          }).catch(() => {})
        );

        // 3. Fetch terminal list
        reqPayload.companyId = companyId;
        reqPayload.dateS = date.toLocaleDateString('en-US');
        reqPayload.employeeId = showAllEmployeeRecords ? 0 : empId;
        if (currentSort && currentSort.length > 0) {
          reqPayload.sort = currentSort;
        }

        promises.push(
          MachineService.terminalList(reqPayload)
            .then((response) => {
              const { dataList } = response.data;
              if (dataList?.length > 0) {
                if (showAllEmployeeRecords) {
                  setClaimAmount('');
                } else {
                  let claimAmountSum = 0;
                  dataList?.forEach((value) => {
                    claimAmountSum += value.loadingAmount;
                  });
                  setClaimAmount(claimAmountSum);
                }
              }
              setList(dataList);
              // Calculate location counts
              if (dataList && dataList.length > 0) {
                const locationsWithLoad = dataList.filter(item => item.loadingAmount > 0).length;
                setLocationsToLoadCount(locationsWithLoad);
                const fifths = dataList.filter(item => {
                  const amount = item.loadingAmount || 0;
                  return amount > 0 && (amount % 10000) === 5000;
                }).length;
                setFifthsCount(fifths);
              } else {
                setLocationsToLoadCount(0);
                setFifthsCount(0);
              }
            }).catch(() => {
              setList([]);
              setLocationsToLoadCount(0);
              setFifthsCount(0);
            })
        );

        // Execute all promises in parallel
        await Promise.all(promises);
      } finally {
        dispatch(setLoadingOverlay(false));
        setIsLoading(false);
      }
    };

    loadAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, empId, showAllEmployeeRecords, search]);

  // NOTE: Removed duplicate useEffect on [date] - already covered by the useEffect above
  // which includes date in its dependencies array [date, empId, showAllEmployeeRecords, search]

  async function updateLoadingTerminalData(payload) {
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    await MachineService.updateLoadingTerminalData(payload)
      .then((response) => {
        const { status, dataList } = response.data;

        if (status === 400) {
          return;
        }

        if (dataList?.length > 0) {
          if (showAllEmployeeRecords) {
            setClaimAmount('');
          } else {
            let claimAmount = 0;
            dataList?.forEach((value) => {
              claimAmount += value.loadingAmount;
            });
            setClaimAmount(claimAmount);
          }
        }
      })
      .catch(() => {
        LocalstorageService.removeItem(INSERT_LOADING_TERMINAL_DATE_KEY);
      })
      .finally(() => {
        setIsLoading(false);
        dispatch(setLoadingOverlay(false));
      });
  }

  const sortBy = (sortObj) => {
    let day = date.toISOString().split('T')[0];
    delete reqPayload.sort;

    // Save the sort to state
    const newSort = sortObj ? [sortObj] : [{ value: 'loadingAmount', asc: false }];
    setCurrentSort(newSort);

    reqPayload['sort'] = newSort;
    reqPayload.companyId = companyId;
    reqPayload.dateS = day;
    reqPayload.employeeId = showAllEmployeeRecords ? 0 : empId;
    listFn();
  };

  async function getTotalAmountToLoad(payload) {
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    await MachineService.toAmountToLoad(payload)
      .then((response) => {
        const { status, dataList } = response.data;

        if (status === 400) {
          return;
        }

        if (dataList?.length > 0) {
          if (payload.employeeId <= 0) {
            setTotalLoadAmount(dataList[0].totalAmountToLoad);
            setClaimAmount('');
          } else {
            setClaimAmount(dataList[0].totalAmountToLoad);
          }
        }
      })
      .finally(() => {
        setIsLoading(false);
        dispatch(setLoadingOverlay(false));
      });
  }

  // getEmployeeFn is now called inside loadAllData's Promise.all for initial load.
  // This standalone version is kept for manual refresh scenarios.
  async function getEmployeeFn() {
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    await EmployeeService.listEmployee({ companyId })
      .then((response) => {
        const { status, dataList } = response.data;

        if (status === 400) {
          return;
        }

        if (dataList && dataList.length) {
          const data = dataList?.map((item) => ({
            id: item.id,
            label: `${item.firstName} ${item.lastName}`,
            value: item.id,
            companyId: item.companyId,
          }));

          setEmpList(data);
        }
      })
      .finally(() => {
        setIsLoading(false);
        dispatch(setLoadingOverlay(false));
      });
  }

  const HeaderList = [
    {
      title: '',  // Edit button column - RIGHT in RTL
      value: 'editAction',
      style: { width: '60px', minWidth: '60px', maxWidth: '60px' },
      sortable: false,
    },
    {
      title: t(`LOAD_TABS.TERMINAL_NUMBER_LABEL`),
      value: 'terminalNumber',
      style: { width: '95px', minWidth: '95px', maxWidth: '95px' },  // מספר מסוף - עד 10 תווים
    },
    {
      title: t(`LOAD_TABS.BUSINESS_NAME_LABEL`),
      value: 'locationName',
      style: { width: '140px', minWidth: '140px', maxWidth: '140px' },  // שם עסק - עד 25 תווים
    },
    {
      title: t(`LOAD_TABS.AT_THE_TERMINAL_LABEL`),
      value: 'sumOfTerminalDrawer',
      style: { width: '95px', minWidth: '95px', maxWidth: '95px' },  // הסכום במסוף - sortable
      sortable: true,
    },
    {
      title: t(`LOAD_TABS.AMOUNT_PASSED_LABEL`),
      value: 'amountPassed',
      style: { width: '100px', minWidth: '100px', maxWidth: '100px' },  // סכום ממוצע המשיכות - sortable
      sortable: true,
    },
    {
      title: t(`LOAD_TABS.AMOUNT_TO_LOAD_LABEL`),
      value: 'loadingAmount',
      style: { width: '100px', minWidth: '100px', maxWidth: '100px' },
    },
    {
      title: t(`LOAD_TABS.EXCESS_OR_LESS_LABEL`),
      value: 'excess',
      style: { width: '95px', minWidth: '95px', maxWidth: '95px' },  // עודף/פחת - sortable
      sortable: true,
    },
    {
      title: t(`LOAD_TABS.REMARKS_LABEL`),
      value: 'remark',
      style: { width: '150px', minWidth: '150px' },  // עמודת הערות - מציגה רק במחשב
      sortable: false,
    },
    {
      title: '',  // Remark button column - LEFT in RTL (no text, just button)
      value: 'remarkAction',
      style: { width: '60px', minWidth: '60px', maxWidth: '60px' },
      sortable: false,
    },
  ];

  async function listFn() {
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));
    await MachineService.terminalList(reqPayload)
      .then((response) => {
        const { status, message, dataList, totalCount } = response.data;

        // if (status === 400) {
        //   toast.error(message);
        //   return;
        // }

        if (dataList?.length > 0) {
          if (showAllEmployeeRecords) {
            setClaimAmount('');
          } else {
            let claimAmount = 0;
            dataList?.forEach((value) => {
              claimAmount += value.loadingAmount;
            });
            setClaimAmount(claimAmount);
          }
        }

        setList(dataList);

        // Calculate location counts
        if (dataList && dataList.length > 0) {
          // Count locations with loadingAmount > 0
          const locationsWithLoad = dataList.filter(item => item.loadingAmount > 0).length;
          setLocationsToLoadCount(locationsWithLoad);

          // Count locations where loadingAmount ends with 5000 (e.g., 5000, 15000, 25000, etc.)
          const fifths = dataList.filter(item => {
            const amount = item.loadingAmount || 0;
            return amount > 0 && (amount % 10000) === 5000;
          }).length;
          setFifthsCount(fifths);
        } else {
          setLocationsToLoadCount(0);
          setFifthsCount(0);
        }
      })
      .finally(() => {
        dispatch(setLoadingOverlay(false));
        setIsLoading(false);
      });
  }

  async function recalculateData(loadTotalAmountForAllEmployee = false) {
    setIsLoading(true);
    dispatch(setLoadingOverlay(true));

    // Apply current sort to request
    if (currentSort && currentSort.length > 0) {
      reqPayload.sort = currentSort;
    }

    await MachineService.reCalculateLoadingTerminalData(reqPayload)
      .then(async (response) => {
        const { status, message, dataList, totalCount } = response.data;

        if (status === 400) {
          toast.error(message);
          return;
        }

        const { dateS, companyId, employeeId } = reqPayload;
        if (loadTotalAmountForAllEmployee) {
          await getTotalAmountToLoad({
            dateS,
            companyId,
            employeeId: 0,
          });
        }

        await getTotalAmountToLoad({
          dateS,
          companyId,
          employeeId,
        });

        // if (dataList?.length > 0) {
        //   let claimAmount = 0;
        //   dataList?.forEach((value) => {
        //     claimAmount += value.loadingAmount;
        //   });

        //   if (showAllEmployeeRecords) {
        //     setTotalAmounts({ claimAmount });
        //   } else {
        //     setTotalAmounts((prev) => {
        //       return { ...prev, claimAmount };
        //     });
        //   }
        // }

        // Apply client-side sorting if server didn't sort
        let sortedData = dataList;
        if (dataList && dataList.length > 0 && currentSort && currentSort.length > 0) {
          const sortField = currentSort[0].value;
          const sortAsc = currentSort[0].asc;
          sortedData = [...dataList].sort((a, b) => {
            const aVal = a[sortField] ?? 0;
            const bVal = b[sortField] ?? 0;
            if (typeof aVal === 'number' && typeof bVal === 'number') {
              return sortAsc ? aVal - bVal : bVal - aVal;
            }
            return sortAsc
              ? String(aVal).localeCompare(String(bVal))
              : String(bVal).localeCompare(String(aVal));
          });
        }

        setList(sortedData);

        // Calculate location counts
        if (sortedData && sortedData.length > 0) {
          // Count locations with loadingAmount > 0
          const locationsWithLoad = sortedData.filter(item => item.loadingAmount > 0).length;
          setLocationsToLoadCount(locationsWithLoad);

          // Count locations where loadingAmount ends with 5000 (e.g., 5000, 15000, 25000, etc.)
          const fifths = sortedData.filter(item => {
            const amount = item.loadingAmount || 0;
            return amount > 0 && (amount % 10000) === 5000;
          }).length;
          setFifthsCount(fifths);
        } else {
          setLocationsToLoadCount(0);
          setFifthsCount(0);
        }
      })
      .finally(() => {
        //  fetchRecords();
        dispatch(setLoadingOverlay(false));
        setIsLoading(false);
      });
  }

  let fieldDecimalScale = 0;
  let useThousandSeparator = true;

  const handleSubmit = () => {
    const companyId = LocalstorageService.getItem(CompanyId);
    reqPayload['companyId'] = companyId;
    // reqPayload['dateS'] = date.toISOString().split('T')[0];
    reqPayload['dateS'] = date.toLocaleDateString('en-US');
    reqPayload['employeeId'] = empId;
    reqPayload['terminalNumber'] = '0';
    reqPayload['NewTotalAmount'] = 0;
    recalculateData();
  };

  const handleUpdateCellValue = (value) => {
    if (changeCellValue.oldValue) {
      const companyId = LocalstorageService.getItem(CompanyId);
      const { employeeId, terminalNumber } = changeCellValue.oldValue;
      reqPayload['companyId'] = companyId;
      // reqPayload['dateS'] = date.toISOString().split('T')[0];
      reqPayload['dateS'] = date.toLocaleDateString('en-US');
      reqPayload['employeeId'] = employeeId;
      reqPayload['terminalNumber'] = terminalNumber;
      reqPayload['NewTotalAmount'] = Number(changeCellValue?.newValue?.replace(/\,/g, ''));
      reqPayload['EditRow'] = true
      // reqPayload['loadingAmount'] = Number(changeCellValue?.newValue?.replace(/\,/g, ''));
      setChangeCellValue({ oldValue: '', newValue: '' });
      recalculateData(true);
    } else {
      setChangeCellValue({ oldValue: value });
    }
  };

  const handleCancelCellvalue = () => {
    setChangeCellValue({ oldValue: '', newValue: '' });
    fetchRecords();
  };
  const handleRemark = (data) => {
    setShowRemarkModal({ shown: true, remarkId: data.remarkId, terminalNumber: data.terminalNumber, locationName: data.locationName });
  };

  return (
    <>
      <Formik
        innerRef={formRef}
        initialValues={InitialValues}
        // validationSchema={ValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, setFieldTouched }) => (
          <Form noValidate>
            {roleId === USER_ROLE.COMPANY_ADMIN ? (
              <>
                <Row className="totalWrapper " style={{ fontSize: '15px' }}>
                  {/* Employee */}
                  {/* <div className="mb-4 d-md-flex justify-content-between"> */}
                  <Col sm={4}>
                    <Form className="search-filter" onSubmit={(e) => e.preventDefault()}>
                      <FormGroup className="">
                        <InputGroup>
                          <Input onChange={debouncedChangeHandler} placeholder={t('SEARCH')} />
                          <Button color="primary" type="button">
                            <i className="ri-search-line"></i>
                          </Button>
                        </InputGroup>
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col sm={4}>
                    <div className="formColumn mb-3 totalAmount">
                      <label>{t(`LOADING_TERMINAL.EMPLOYEE`)}</label>
                      <ReactSelect
                        name={'employee'}
                        value={showAllEmployeeRecords ? '' : empList.filter(({ value }) => value === empId)}
                        options={empList}
                        className="react-select "
                        onChange={(option) => {
                          setShowAllEmployeeRecords(option ? false : true);
                          setFieldValue('employee', option?.value);
                          setEmpId(option?.value);
                        }}
                        onBlur={() => setFieldTouched('employee', true)}
                        placeholder={`-- ${t('LOADING_TERMINAL.EMPLOYEE')} --`}
                        noOptionsMessage={() => t('RSEL_NO_OPT')}
                        isClearable
                      />
                    </div>
                  </Col>
                </Row>
                {/* Summary row - RTL order: 1.הסכום הכללי(right) 2.סכום שיש לעובד 3.הסכום לטעינה 4.מספר מקומות 5.חמישיות(left) */}
                <Row style={{ fontSize: '15px' }} className="totalWrapper align-items-stretch">
                  <Col xs={6} sm={4} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.REMAINING_LOAD_AMOUNT`)}
                      </label>
                      <NumericFormat
                        name={'totalLoadAmount'}
                        className="form-control"
                        value={totalLoadAmount}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={fieldDecimalScale}
                        {...(fieldDecimalScale > 0 ? { fixedDecimalScale: true } : {})}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                  <Col xs={6} sm={4} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.TOTAL_EMPLOYEE_AMOUNT`)}
                      </label>
                      <NumericFormat
                        name={'amountEmployeeHave'}
                        className="form-control"
                        value={amountEmployeeHave}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={fieldDecimalScale}
                        {...(fieldDecimalScale > 0 ? { fixedDecimalScale: true } : {})}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                  <Col xs={6} sm={4} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.TOTAL_LOAD_AMOUNT`)}
                      </label>
                      <NumericFormat
                        name={'claimAmount'}
                        className="form-control"
                        value={claimAmount}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={fieldDecimalScale}
                        {...(fieldDecimalScale > 0 ? { fixedDecimalScale: true } : {})}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                  <Col xs={6} sm={6} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.LOCATIONS_TO_LOAD_COUNT`) || 'מספר מקומות לטעינה'}
                      </label>
                      <NumericFormat
                        name={'locationsToLoadCount'}
                        className="form-control"
                        value={locationsToLoadCount}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={0}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                  <Col xs={6} sm={6} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.FIFTHS_COUNT`) || 'מספר החמישיות'}
                      </label>
                      <NumericFormat
                        name={'fifthsCount'}
                        className="form-control"
                        value={fifthsCount}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={0}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row style={{ fontSize: '15px' }}>
                  {/* Employee */}
                  <Col sm={2}>
                    <Form className="search-filter" onSubmit={(e) => e.preventDefault()}>
                      <FormGroup className="">
                        <InputGroup>
                          <Input onChange={debouncedChangeHandler} placeholder={t('SEARCH')} />
                          <Button color="primary" type="button">
                            <i className="ri-search-line"></i>
                          </Button>
                        </InputGroup>
                      </FormGroup>
                    </Form>
                  </Col>
                  <Col sm={4}>
                    <div className="formColumn mb-3 totalAmount">
                      <label className="me-2">{t(`LOADING_TERMINAL.EMPLOYEE`)}</label>
                      <ReactSelect
                        name={'employee'}
                        value={showAllEmployeeRecords ? '' : empList.filter(({ value }) => value === empId)}
                        options={empList}
                        className="react-select"
                        onChange={(option) => {
                          setShowAllEmployeeRecords(false);
                          setFieldValue('employee', option?.value);
                          setEmpId(option?.value);
                        }}
                        onBlur={() => setFieldTouched('employee', true)}
                        placeholder={`-- ${t('LOADING_TERMINAL.EMPLOYEE')} --`}
                        noOptionsMessage={() => t('RSEL_NO_OPT')}
                        isClearable
                      />
                    </div>
                  </Col>
                </Row>
                {/* Summary row - RTL order: 1.הסכום הכללי(right) 2.סכום שיש לעובד 3.הסכום לטעינה 4.מספר מקומות 5.חמישיות(left) */}
                <Row style={{ fontSize: '15px' }} className="totalWrapper align-items-stretch">
                  <Col xs={6} sm={4} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.REMAINING_LOAD_AMOUNT`)}
                      </label>
                      <NumericFormat
                        name={'totalLoadAmount2'}
                        className="form-control"
                        value={totalLoadAmount}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={fieldDecimalScale}
                        {...(fieldDecimalScale > 0 ? { fixedDecimalScale: true } : {})}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                  <Col xs={6} sm={4} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.TOTAL_EMPLOYEE_AMOUNT`)}
                      </label>
                      <NumericFormat
                        name={'amountEmployeeHave2'}
                        className="form-control"
                        value={amountEmployeeHave}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={fieldDecimalScale}
                        {...(fieldDecimalScale > 0 ? { fixedDecimalScale: true } : {})}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                  <Col xs={6} sm={4} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.TOTAL_LOAD_AMOUNT`)}
                      </label>
                      <NumericFormat
                        name={'claimAmount2'}
                        className="form-control"
                        value={claimAmount}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={fieldDecimalScale}
                        {...(fieldDecimalScale > 0 ? { fixedDecimalScale: true } : {})}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                  <Col xs={6} sm={6} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.LOCATIONS_TO_LOAD_COUNT`) || 'מספר מקומות לטעינה'}
                      </label>
                      <NumericFormat
                        name={'locationsToLoadCount2'}
                        className="form-control"
                        value={locationsToLoadCount}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={0}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                  <Col xs={6} sm={6} md={true} className="mb-2">
                    <div className="formColumn totalAmount h-100 d-flex flex-column">
                      <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>
                        {t(`LOADING_TERMINAL.FIFTHS_COUNT`) || 'מספר החמישיות'}
                      </label>
                      <NumericFormat
                        name={'fifthsCount2'}
                        className="form-control"
                        value={fifthsCount}
                        allowNegative={false}
                        thousandSeparator={useThousandSeparator}
                        decimalScale={0}
                        disabled={true}
                        autoComplete="off"
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  </Col>
                </Row>
              </>
            )}
            <div className="dataMin">
              <Table
                className="fixTh dataTable"
                striped
                bordered
                responsive
                size="sm"
                style={{ minWidth: '900px', tableLayout: 'fixed' }}
              >
                <thead>
                  <tr className="TableRow">
                    <SortableHeader headers={HeaderList} isDisabled={list?.length === 0} sortClick={sortBy} showActionCol={false} />
                  </tr>
                </thead>

                <tbody>
                  {!isLoading &&
                    list?.map((item, l0Idx) => {
                      // Check if item has a non-empty remark - handle null, undefined, empty string, and '-'
                      // Also check remarkId > 0 as an indicator that there's an active remark
                      const remarkValue = item.remark;
                      const hasRemarkText = remarkValue != null &&
                        remarkValue !== '' &&
                        String(remarkValue).trim() !== '' &&
                        String(remarkValue).trim() !== '-';
                      const hasRemarkId = item.remarkId != null && item.remarkId > 0;
                      const hasRemark = hasRemarkText || hasRemarkId;

                      // Determine remark color based on type
                      const getRemarkColor = () => {
                        if (!hasRemark) return 'inherit';
                        const remarkStr = String(remarkValue || '').trim();
                        if (remarkStr.includes('נא לספור')) {
                          return '#008000'; // Green - please count
                        } else if (remarkStr.includes('יש לנקות קורא כרטיסים') || remarkStr.includes('נא לנקות קורא כרטיסים')) {
                          return '#FCB92C'; // Yellow - card reader cleaning
                        }
                        return '#FF0000'; // Red - general note
                      };
                      const remarkColor = getRemarkColor();

                      return (
                        <tr className="TableRow" key={l0Idx} style={{ height: '40px' }}>
                          {/* Edit button - RIGHT in RTL */}
                          <td style={{ width: '60px', minWidth: '60px', maxWidth: '60px', padding: '4px' }}>
                            {changeCellValue.oldValue === item ? (
                              <Button
                                color="success"
                                size="sm"
                                className="tableBtn"
                                onClick={() => handleUpdateCellValue(item)}
                              >
                                {t(`LOAD_TABS.SAVE`)}
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                size="sm"
                                className="tableBtn"
                                onClick={() => handleUpdateCellValue(item)}
                              >
                                {t(`LOAD_TABS.EDIT_BTN`)}
                              </Button>
                            )}
                          </td>
                          <td
                            className="text-center text-truncate"
                            style={{ width: '95px', minWidth: '95px', maxWidth: '95px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                            title={item.terminalNumber}
                          >
                            {item.terminalNumber}
                          </td>
                          <td
                            className="text-truncate"
                            style={{
                              width: '140px',
                              minWidth: '140px',
                              maxWidth: '140px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              color: remarkColor,
                              fontWeight: hasRemark ? 'bold' : 'normal'
                            }}
                            title={item.locationName}
                          >
                            {item.locationName}
                          </td>
                          <td className="text-center" style={{ width: '95px', minWidth: '95px', maxWidth: '95px' }} dir="ltr">
                            {formatNumberRTL(item.sumOfTerminalDrawer)}
                          </td>
                          <td className="text-center" style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }} dir="ltr">
                            {formatNumberRTL(item.amountPassed)}
                          </td>
                          <td className="text-center" style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }} dir="ltr">
                            {changeCellValue.oldValue === item ? (
                              <NumericFormat
                                name={`amountToLoad${l0Idx}`}
                                className="form-control"
                                value={changeCellValue.newValue}
                                allowNegative={false}
                                thousandSeparator={useThousandSeparator}
                                decimalScale={fieldDecimalScale}
                                {...(fieldDecimalScale > 0 ? { fixedDecimalScale: true } : {})}
                                onChange={(e) => {
                                  setChangeCellValue((prev) => {
                                    return { ...prev, newValue: e.target.value };
                                  });
                                }}
                                autoComplete="off"
                                style={{ padding: '2px 4px', height: '30px' }}
                              />
                            ) : (
                              formatNumberRTL(item.loadingAmount)
                            )}
                          </td>
                          <td className="text-center" style={{ width: '95px', minWidth: '95px', maxWidth: '95px' }} dir="ltr">
                            {formatNumberRTL(item.excess)}
                          </td>
                          {/* Remark column - shows truncated remark text */}
                          <td
                            className="text-truncate"
                            style={{
                              width: '150px',
                              minWidth: '150px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              fontSize: '12px'
                            }}
                            title={hasRemark ? item.remark : ''}
                          >
                            {hasRemark ? item.remark : ''}
                          </td>
                          {/* Remark button - LEFT in RTL - color changes based on whether remark exists */}
                          <td style={{ width: '60px', minWidth: '60px', maxWidth: '60px', padding: '4px' }}>
                            {changeCellValue.oldValue === item ? (
                              <Button
                                color="danger"
                                size="sm"
                                className="tableBtn"
                                onClick={() => handleCancelCellvalue()}
                              >
                                {t(`LOAD_TABS.CANCEL_BTN`)}
                              </Button>
                            ) : (
                              <Button
                                color={hasRemark ? 'warning' : 'success'}
                                size="sm"
                                className="tableBtn"
                                onClick={() => handleRemark(item)}
                                title={hasRemark ? item.remark : ''}
                              >
                                {t(`REMARK`)}
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}

                  {(isLoading || list?.length === 0) && <NoRecords colSpan={HeaderList.length} />}
                </tbody>
              </Table>
            </div>

            <Row className="align-items-center">
              {/* תאריך טעינה - ימין */}
              <Col sm={3} className="text-end">
                <div className="formColumn flex-wrap mb-3 d-flex justify-content-end align-items-center">
                  <label className="datePickerLabel me-2">{t(`LOADING_TERMINAL.START_DAY`)}</label>
                  <div className="startDay">
                    <ReactDatePicker
                      name="date"
                      className="form-control"
                      selected={date}
                      onChange={(dateArr) => setDate(dateArr)}
                      dateFormat={'dd/MM/yyyy'}
                      shouldCloseOnSelect={true}
                      highlightDates={[new Date()]}
                    />
                  </div>
                </div>
              </Col>

              {/* חשב מחדש */}
              <Col sm={2}>
                <div className="d-flex justify-content-center mb-3">
                  <Button
                    disabled={!empId && !showAllEmployeeRecords}
                    color="primary"
                    type="submit"
                    className="recalculateBtn"
                  >
                    {t(`LOADING_TERMINAL.RE_CALCULATE_BTN`)}
                  </Button>
                </div>
              </Col>

              {/* כל העובדים */}
              <Col sm={2}>
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <Input
                    type="checkbox"
                    className="me-2"
                    id="allEmployee"
                    checked={showAllEmployeeRecords}
                    disabled={showAllEmployeeRecords}
                    onChange={() => {
                      setShowAllEmployeeRecords(!showAllEmployeeRecords);
                      setEmpId(0);
                    }}
                  />
                  <label htmlFor="allEmployee">{t(`LOADING_TERMINAL.ALL_EMPLOYEES`)}</label>
                </div>
              </Col>

              {/* רווח באמצע */}
              <Col sm={2}></Col>

              {/* כפתורי תיקון ומחיקה - שמאל קיצוני */}
              {(roleId === USER_ROLE.COMPANY_ADMIN || roleId === USER_ROLE.SUPER_ADMIN) && (
                <Col sm={3} className="text-start">
                  <div className="d-flex justify-content-start gap-1 mb-3">
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => setShowDeleteModal(true)}
                    >
                      🗑️ {t('LOADING_TERMINAL_BUTTONS.DELETE_DATA')}
                    </Button>
                    <Button
                      color="success"
                      size="sm"
                      disabled={issuesCount === 0}
                      onClick={() => setShowIssuesModal(true)}
                      style={{ opacity: issuesCount === 0 ? 0.6 : 1 }}
                    >
                      🔧 {t('LOADING_TERMINAL_BUTTONS.FIX_ISSUES')}
                      {issuesCount > 0 && (
                        <span className="badge bg-light text-danger ms-1">{issuesCount}</span>
                      )}
                    </Button>
                  </div>
                </Col>
              )}
            </Row>
          </Form>
        )}
      </Formik>
      {showRemarkModal.shown && (
        <RemarkModal showRemarkModal={showRemarkModal} setShowRemarkModal={setShowRemarkModal} />
      )}

      {/* Terminal Issues Modal */}
      <TerminalIssuesModal
        isOpen={showIssuesModal}
        toggle={() => setShowIssuesModal(false)}
        onFixComplete={() => {
          checkIssuesCount();
          fetchRecords();
        }}
      />

      {/* Delete Calculation Modal */}
      <DeleteCalculationModal
        isOpen={showDeleteModal}
        toggle={() => setShowDeleteModal(false)}
        date={date}
        onDeleteComplete={() => {
          fetchRecords();
        }}
      />
    </>
  );
};

export default ListEmployeeTerminals;